import {
    assignmentText,
    measurement,
} from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/helpers';

import updateTable from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/shared/lni-janitorial-job-plan-table/actions/updateTable.ts';

export default () => ({
    state: {
        editable: true,
    },
    getters: {
        tableData: (state, getters, rootState) => {
            const items = rootState.appState?.jobPlan || [];
            const result = [];
            items.forEach((item, index) => {
                let assignment = assignmentText(item);
                if (state.editable) {
                    assignment = `<span class="lnicon--new-message lni-u-pr1" aria-hidden="true"></span> ${assignment}`;
                }
                const data = {
                    index: index + 1,
                    assignment,
                    duration: `${item.hours} ${Number(item.hours) === 1 ? 'hour' : 'hours'} ${item.minutes} ${Number(item.minutes) === 1 ? 'minute' : 'minutes'}`,
                    quantity: `${item.quantity} ${measurement(rootState.appState?.data.measurementTypes, item.measurement).text}`,
                };
                if (state.editable) {
                    data.action = '<span class="lnicon--remove lni-u-pr1" aria-hidden="true"></span> Remove';
                }
                result.push(data);
            });
            return result;
        },
    },
    actions: {
        updateTable,
    },
});